import { render } from "./ModalMenu.vue?vue&type=template&id=2cb02598&scoped=true"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"

import "./ModalMenu.vue?vue&type=style&index=0&id=2cb02598&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cb02598"

export default script